import { render, staticRenderFns } from "./softwareList.vue?vue&type=template&id=5db51576&scoped=true"
import script from "./softwareList.vue?vue&type=script&lang=js"
export * from "./softwareList.vue?vue&type=script&lang=js"
import style0 from "./softwareList.vue?vue&type=style&index=0&id=5db51576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db51576",
  null
  
)

export default component.exports